import { Link } from "@inertiajs/react";
import Avatar from "hardcover-ui/components/Avatar";
import classNames from "lib/classNames";
import { AVATAR_URL } from "lib/imageTools";
import { useState } from "react";
import { CharacterSerializersBookCharacterByline } from "types/serializers";

export default function BookCharacterLink({
  bookCharacter,
}: {
  bookCharacter: CharacterSerializersBookCharacterByline;
}) {
  const [isBlurred, setIsBlurred] = useState(bookCharacter.spoiler);

  function toggleBlurred(event) {
    if (isBlurred) {
      event.preventDefault();
      setIsBlurred(false);
    }
  }

  return (
    <Link
      href={`/characters/${bookCharacter.character.slug}`}
      className={classNames(
        "flex p-2 flex-row items-center space-x-4 hover:bg-gray-100 dark:hover:bg-gray-900",
        "my-2 rounded-sm border border-gray-200 dark:border-gray-700",
        isBlurred ? "blur-lg" : ""
      )}
      onClick={(event) => toggleBlurred(event)}
    >
      <Avatar
        image={{
          id: bookCharacter.character.id,
          url: AVATAR_URL,
        }}
        size="md"
        alt={bookCharacter.character.name.substring(0, 40)}
      />
      <span>{bookCharacter.character.name}</span>
    </Link>
  );
}
